<template>
    <div class="field drop-shadow">
        <div class="staged-candidate" :class="{selected : diff.selected === 'sc'}" @click="selectSrc('sc')" title="Data from Staged Candidate">
            <div class="inner">
                <div class="title-block">
                    <div class="status-label">{{name | splitCamel}}</div>
                    <h4 v-if="diff.sc" :class="{reduced : reduce(scLabel || scAsDate || diff.sc)}">{{scLabel || scAsDate || diff.sc}}</h4>
                    <h4 v-else class="no-val">No Value</h4>
                </div>
                <div class="icon">
                    <div class="tick"><SvgTick fill="#93c57a"/></div>
                    <div class="cross"><SvgCross fill="#ca3d3d"/></div>
                </div>
            </div>
        </div>
        <div class="salesforce" :class="{selected : diff.selected === 'sf'}" @click="selectSrc('sf')" title="Data from Salesforce">
            <div class="inner">
                <div class="title-block">
                    <div class="status-label">{{name | splitCamel}}</div>
                    <h4 v-if="diff.sf" :class="{reduced : reduce(sfLabel || sfAsDate || diff.sf)}">{{sfLabel || sfAsDate || diff.sf}}</h4>
                    <h4 v-else class="no-val">No Value</h4>
                </div>
                <div class="icon">
                    <div class="tick"><SvgTick fill="#93c57a"/></div>
                    <div class="cross"><SvgCross fill="#ca3d3d"/></div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import SvgTick from '../vue-components/src/components/core/icons/SvgTick';
    import SvgCross from '../vue-components/src/components/core/icons/SvgCross';

    export default {
        name: "DiffField",
        components: {SvgTick, SvgCross},
        props: [
            'name',
            'lookup'
        ],
        data: function() {
            return {
                sfSelected: true,
                scSelected: false
            }
        },
        computed: {
            diff() {
                return this.$store.state.cvUpload.stagedCandidateDiff[this.name];
            },
            lookups() {
                return this.$store.state.app.lookup || [];
            },
            scLabel() {
                return this.getLabel('sc');
            },
            sfLabel() {
                return this.getLabel('sf');
            },
            scAsDate() {
                let asDate = this.$options.filters['formatDate'](this.diff.sc);
                if (this.diff.sc.match(/^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])/g) && asDate !== 'Invalid date'){
                    return asDate;
                } else {
                    return null;
                }
            },
            sfAsDate() {
                let asDate = this.$options.filters['formatDate'](this.diff.sf);
                if (this.diff.sf.match(/^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])/g) && asDate !== 'Invalid date'){
                    return asDate;
                } else {
                    return null;
                }
            },
            isReduced() {
                
                return true;
            }
        },
        methods: {
            selectSrc(src) {
                this.$store.commit('selectStagedCandidateDiff', {'name': this.name, 'src': src});
            },
            getLabel(src){
                if (this.lookups[this.diff.lookup]) {
                    for (let i = 0; i < this.lookups[this.diff.lookup].length; i++) {
                        if (this.lookups[this.diff.lookup][i].value === this.diff[src]) {
                            return this.lookups[this.diff.lookup][i].label;
                        }
                    }
                }
                return null;
            },
            reduce(label) {
                if (label && label.length >= 28) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }
</script>

<style scoped>

    .field {display: flex;  margin-bottom: .75rem;}
        .field > div {width: 50%; max-width: 50%; background: #fff; cursor: pointer; position: relative; transition: .25s; border: solid 1px #000; user-select: none;}
        .field > div:hover {background: #efefef;}
        .field > .staged-candidate {padding: 1rem 2.5rem 1rem 1.5rem;}
        .field > .salesforce {padding: 1rem 1.5rem 1rem 2.5rem;}
        .field > div + div {border-left: none;}
        .field > div:not(.selected) {background: #ababab;}
        .field > div:not(.selected):hover {background: #bcbcbc;}
            .field > div:not(.selected) .title-block {opacity: .6;}
        .field .title-block {margin-bottom: 0;}
            .field .title-block h4 {overflow-wrap: break-word; word-break: break-word;}

        .field .inner {display: flex; align-items: center; height: 100%;}
            .field .inner .title-block {flex-grow: 1;}
                .field .inner .title-block .no-val {font-style: italic; color: var(--colour-primary);}
                .field .inner .title-block h4 {text-transform: initial;}
                .field .inner .title-block h4.reduced {font-size: .95rem;}
            .field .inner .icon {max-width: 2rem; min-width: 2rem; height: 2rem; position: relative; margin-left: 1rem;}
                .field .inner .icon > div {position: absolute; top: 0; right: 0; left: 0; bottom: 0; transform: scale(0); transition: .25s;}
                .field .inner .icon > .tick {transform: scale(0);}
                .field .selected .inner .icon > .tick {transform: scale(1);}
                .field .inner .icon > .cross {transform: scale(1);}
                .field .selected .inner .icon > .cross {transform: scale(0);}



        /* Arrows Staged*/
        .field .staged-candidate:before {content:''; display: block; position: absolute; right: -1rem; top: 0; bottom: 0; margin: auto; z-index: 9; opacity: 0;
            width: 0; height: 0; border-style: solid; border-width: .75rem 0 .75rem 1rem; border-color: transparent transparent transparent #000;}
        .field .staged-candidate.selected:before {opacity: 1;}

        .field .staged-candidate:after {content:''; display: block; position: absolute; right: calc(-1rem + 1px); top: 0; bottom: 0; margin: auto; z-index: 10; opacity: 0;
            width: 0; height: 0; border-style: solid; border-width: .75rem 0 .75rem 1rem; border-color: transparent transparent transparent #fff;}
        .field .staged-candidate.selected:after { opacity: 1;}

        .field .staged-candidate .inner:after {content:''; display: block; position: absolute; right: .5rem; top: 0; bottom: 0; margin: auto; z-index: 11; opacity: 0; transition: opacity .5s, right 0;
            width: 0; height: 0; border-style: solid; border-width: .75rem 0 .75rem 1rem; border-color: transparent transparent transparent var(--colour-primary);}
        .field .staged-candidate.selected .inner:after {opacity: 1; right: -.5rem; transition: .5s;}


        /* Arrows Salesforce */
        .field .salesforce:before {content:''; display: block; position: absolute; left: -1rem; top: 0; bottom: 0; margin: auto; z-index: 9; opacity: 0;
            width: 0; height: 0; border-style: solid; border-width: .75rem 1rem .75rem 0; border-color: transparent #000 transparent transparent;}
        .field .salesforce.selected:before {opacity: 1;}

        .field .salesforce:after {content:''; display: block; position: absolute; left: calc(-1rem + 1px); top: 0; bottom: 0; margin: auto; z-index: 10; opacity: 0;
            width: 0; height: 0; border-style: solid; border-width: .75rem 1rem .75rem 0; border-color: transparent #fff transparent transparent;}
        .field .salesforce.selected:after {opacity: 1;}

        .field .salesforce .inner:after {content:''; display: block; position: absolute; left: .5rem; top: 0; bottom: 0; margin: auto; z-index: 11; opacity: 0; transition: opacity .5s, left 0;
            width: 0; height: 0; border-style: solid; border-width: .75rem 1rem .75rem 0; border-color: transparent var(--colour-primary) transparent transparent;}
        .field .salesforce.selected .inner:after {opacity: 1; left: -.5rem; transition: .5s;}
        
</style>